import React from 'react'
import ReactDOM from 'react-dom/client'

import 'react-datepicker/dist/react-datepicker.css'
import './style/colors.scss'
import './style/elements.scss'
import './style/components.scss'
import './style/header.scss'
import './style/footer.scss'
import './main.scss'
import 'react-activity/dist/Dots.css'

import App from './App'
import reportWebVitals from './reportWebVitals'

import { ApolloClient, InMemoryCache, from, ApolloProvider } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { createUploadLink } from 'apollo-upload-client'
import { setContext } from 'apollo-link-context'

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import I18NextChainedBackend from 'i18next-chained-backend'
import resourcesToBackend from 'i18next-resources-to-backend'
import { et } from './translations'


const bundledResources = {
  et: {
    translations: et,
  },
}

i18n
  .use(I18NextChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: ['translations'],
    defaultNS: 'translations',
    compatibilityJSON: 'v3',
    fallbackLng: 'et',
    partialBundledLanguages: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      backends: [
        HttpBackend,
        resourcesToBackend(bundledResources),
      ],
      backendOptions: [
        {
          // loadPath: 'https://eau.nordro.se/translations/{{lng}}.json',
          crossDomain: true,
        },
      ],
    },
  }
)

const root = ReactDOM.createRoot(document.getElementById('root'))

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token')
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
})

const errorLink = onError(({ graphQLErrors, networkError, response, operation }) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(graphQLErrors)
    if (graphQLErrors?.length > 0 && graphQLErrors[0].message === 'Invalid credentials') throw new Error('Invalid credentials') 
  }
})

const httpLink = createUploadLink({
  uri: process.env.NODE_ENV !== 'development' ? process.env.REACT_APP_GRAPHQL : 'http://localhost:3050/graphql',
  credentials: 'include',
})

const client = new ApolloClient({
  ssrMode: false,
  link: from([
    authLink,
    errorLink,
    httpLink,
  ]),
  connectToDevTools: process.env.NODE_ENV === 'development',
  cache: new InMemoryCache(),
})

root.render(
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
